export default {
  Login: {
    TITLE: 'Welcome back',
    SIGN_IN_WITH_XERO: 'Sign in with Xero',
    NOT_CREATED: 'Looks like you don\'t have a Mayday account yet!',
    SIGN_UP: 'Sign up here',
  },
};
